var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CabeceraTabla", {
        scopedSlots: _vm._u([
          {
            key: "izquierda",
            fn: function() {
              return [
                _c("BuscadorOperacionCrud", {
                  attrs: {
                    filter:
                      _vm.gridApi &&
                      _vm.gridApi.setQuickFilter.bind(_vm.gridApi),
                    prepend: "directions_car"
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm.readonly
        ? _c("MantenedorGridVerDetalle", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "row-data": _vm.etiquetasSeleccionadas
            }
          })
        : _c("AsociacionGrid", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "row-data": _vm.etiquetas,
              esEditar: _vm.esEditar
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }